import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import { isPlatformActive } from "../platform/getCurrentPlatform";
var extend = Object.assign;
export default (function (adapter, options) {
  var platform = options.platform,
      methods = options.methods;
  if (!isPlatformActive(platform)) return;
  console.warn(Object.keys(methods));
  console.warn("当前页面含有hotfix插件，可能会有紧急上线的情况，请联系adapter维护者进行修复");
  extend(adapter.constructor.prototype, methods);
});